import { Locale, LocaleDirection, getUIDirection, defaultLocale } from '.';

export type LocalizationAttributes = {
  lang: Locale;
  dir: LocaleDirection;
};

/**
 * Set localization attributes of current document
 * @param localization : Localization parameters to set
 */
export function setLocalizationAttributes(localization: LocalizationAttributes | undefined) {
  document.documentElement.setAttribute('dir', localization?.dir || <LocaleDirection>getUIDirection(defaultLocale));
  document.documentElement.setAttribute('lang', localization?.lang || defaultLocale);
}

/**
 * Get localization attributes of current document
 */
export function getLocalizationAttributes(): LocalizationAttributes {
  return {
    dir: <LocaleDirection>document.documentElement.getAttribute('dir') || getUIDirection(defaultLocale),
    lang: <Locale>document.documentElement.getAttribute('lang') || defaultLocale
  };
}
